import {useContext} from 'react';
import ProductContext from 'product_details_page/Context/productContext';

export const MAX_KEY_BENEFITS = 4;

export default function useProductKeyBenefits() {
  const {keyBenefits} = useContext(ProductContext);

  return Array.isArray(keyBenefits)
    ? keyBenefits.slice(0, MAX_KEY_BENEFITS)
    : [];
}
